import "./Politicas.css";

export default function Garantia() {
  return (
    <div className="politicas-container">
      <h1>Política de Garantía</h1>

      <ul>
        <li>Cubre únicamente defectos de fabricación.</li>
        <li>No cubre daños por mal uso, accidentes, modificaciones o desgaste natural.</li>
        <li>Plazo de garantía: según tipo de producto, generalmente entre 30 y 90 días.</li>
        <li>El cliente debe reportar fallas a soporte para validar la garantía.</li>
        <li>Se puede reparar, reemplazar o reembolsar el producto según evaluación.</li>
      </ul>
    </div>
  );
}
